export default [
  {
    // 교육/강좌
    path: 'lect',
    redirect: { name: 'LectDailyPaymentList' },
    children: [
      {
        // 마감관리
        path: 'daily-report-mng',
        redirect: { name: 'LectClosingManage' },
        children: [
          {
            path: 'list',
            name: 'LectClosingManage',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/dailyReportMng/ClosingManageListView.vue')
          }
        ]
      },
      {
        // 일일 납입내역
        path: 'daily-payment-history',
        redirect: { name: 'LectDailyPaymentList' },
        children: [
          {
            path: 'list',
            name: 'LectDailyPaymentList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyPaymentListView.vue')
          }
        ]
      },
      {
        // 결의서
        path: 'resolutions',
        redirect: { name: 'LectDailyResolutionList' },
        children: [
          {
            path: 'list',
            name: 'LectDailyResolutionList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyResolutionListView.vue')
          }
        ]
      },
      {
        // 결제/환불 신청 현황
        path: 'payment-refund-status',
        redirect: { name: 'LectRequestStatusList' },
        children: [
          {
            path: 'list',
            name: 'LectRequestStatusList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/RequestStatusListView.vue')
          }
        ]
      },
      {
        // 일일상품 결제/환불 일보
        path: 'daily-product-payment',
        redirect: { name: 'LectDailyIncomeList' },
        children: [
          {
            path: 'list',
            name: 'LectDailyIncomeList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyIncomeListView.vue')
          }
        ]
      },
      {
        // 일일 영업일보
        path: 'daily-sales-report',
        redirect: { name: 'LectDailySalesList' },
        children: [
          {
            path: 'list',
            name: 'LectDailySalesList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailySalesListView.vue')
          }
        ]
      },
      {
        // 품목(시설)별 영업일보
        path: 'item-sales-report',
        redirect: { name: 'LectDdsDailyReportByGdsList' },
        children: [
          {
            path: 'list',
            name: 'LectDdsDailyReportByGdsList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyReportByGdsListView.vue')
          }
        ]
      },
      {
        // 품목 구분별 영업일보
        path: 'item-type-sales-report',
        redirect: { name: 'LectDdsDailyReportByGdsClsfList' },
        children: [
          {
            path: 'list',
            name: 'LectDdsDailyReportByGdsClsfList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyReportByGdsClsfListView.vue')
          }
        ]
      },
      {
        // 회원 영업일보
        path: 'member-sales-report',
        redirect: { name: 'LectMemberReportList' },
        children: [
          {
            path: 'list',
            name: 'LectMemberReportList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/MemberReportListView.vue')
          }
        ]
      },
      {
        // 환불 회원 현황
        path: 'refund-member-status',
        redirect: { name: 'LectMemberRequestStatusList' },
        children: [
          {
            path: 'list',
            name: 'LectMemberRequestStatusList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/MemberRequestStatusListView.vue')
          }
        ]
      },
      {
        // 카드 승인/취소 내역
        path: 'card-approval-history',
        redirect: { name: 'LectDssCardHistoryList' },
        children: [
          {
            path: 'list',
            name: 'LectDssCardHistoryList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/CardHistoryListView.vue')
          }
        ]
      },
      {
        // 매출 현황
        path: 'sales-status',
        redirect: { name: 'LectTotalSalesStatusList' },
        children: [
          {
            path: 'list',
            name: 'LectTotalSalesStatusList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/TotalSalesStatusListView.vue')
          }
        ]
      },
      {
        // 강사 수당 청구서
        path: 'instructor-bill',
        redirect: { name: 'LectDailyInstrClmList' },
        children: [
          {
            path: 'list',
            name: 'LectDailyInstrClmList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyInstrClmListView.vue')
          }
        ]
      },
      {
        // 강사 수당 지급내역
        path: 'instructor-payment',
        redirect: { name: 'LectDailyInstrPaymentList' },
        children: [
          {
            path: 'list',
            name: 'LectDailyInstrPaymentList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DailyInstrPaymentListView.vue')
          }
        ]
      },
      {
        // 근무자별 영업일보
        path: 'worker-sales-report',
        redirect: { name: 'LectDlyrpEmplyList' },
        children: [
          {
            path: 'list',
            name: 'LectDlyrpEmplyList',
            meta: { menu: 'lect', keepAlive: true },
            component: () => import('@/pages/reportMng/lect/DlyrpEmplyListView.vue')
          }
        ]
      }
    ]
  }
]
